import { render, staticRenderFns } from "./RewardRequestList.vue?vue&type=template&id=36f19db6&"
import script from "./RewardRequestList.vue?vue&type=script&lang=js&"
export * from "./RewardRequestList.vue?vue&type=script&lang=js&"
import style0 from "./RewardRequestList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports